export interface ArtStyleGridGeometry {
  columns: number;
  imageHeight: number;
  imageWidth: number;
  rows: number;
}

export function artStyleGridLayout(
  count: number,
  width: number,
  height: number,
  ratio: number,
  gap: number,
  labelHeight: number
): ArtStyleGridGeometry {
  const maxColumns = Math.min(
    Math.max(count, 1),
    width >= height ? 4 : 2,
    Math.max(1, Math.floor((width + gap) / (112 + gap)))
  );
  let columns = maxColumns;
  let imageHeight = 0;

  for (let candidate = 1; candidate <= maxColumns; candidate++) {
    const rows = Math.ceil(count / candidate) || 1;
    const cellWidth = (width - gap * (candidate - 1)) / candidate;
    const cellHeight = (height - gap * (rows - 1)) / rows - labelHeight;
    const fittedHeight = Math.min(cellWidth / ratio, cellHeight);
    if (fittedHeight > imageHeight + 1) {
      columns = candidate;
      imageHeight = fittedHeight;
    }
  }

  // Keep small screens scrollable rather than shrinking previews to unusable targets.
  imageHeight = Math.max(
    imageHeight,
    Math.min(
      Math.max(96, 112 / ratio),
      (width - gap * (columns - 1)) / columns / ratio
    )
  );

  return {
    columns,
    imageHeight,
    imageWidth: imageHeight * ratio,
    rows: Math.ceil(count / columns) || 1,
  };
}

export function artStyleGridColumnStart(
  index: number,
  count: number,
  columns: number
): number | undefined {
  const remainder = count % columns;
  return remainder > 0 && index === count - remainder
    ? columns - remainder + 1
    : undefined;
}
